import * as React from "react";
import { useState } from "react";
import { State } from "@progress/kendo-data-query";
import { IconButton, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query/dist/npm/filtering/filter-descriptor.interface";
import { StandardTextFieldProps } from "@mui/material/TextField/TextField";
import { applyFilter } from "./ApplyFilter";
import { buildFilter } from "./BuildFilter";
import { removeFieldsFromCurrentFilter } from "./RemoveFieldsFromCurrentFilter";

export default function MdmQuickFilter({
  currentDataState,
  setDataState,
  findText,
  filterFields,
  builder = buildFilter,
  ...props
}: {
  currentDataState: State;
  setDataState: React.Dispatch<React.SetStateAction<State>>;
  findText: string;
  filterFields: string[];
  builder?: (fields: string[], value: string) => CompositeFilterDescriptor;
} & StandardTextFieldProps) {
  const [inputValue, setInputValue] = useState("");
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      setFilter();
      event.stopPropagation();
    }
  };

  const handleInputChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const setFilter = () => {
    removeFieldsFromCurrentFilter(filterFields, currentDataState);

    if (currentDataState.filter?.filters.length === 0) {
      currentDataState.filter = undefined;
      setDataState({
        ...currentDataState,
      });
    }

    if (inputValue && inputValue.length > 0) {
      const filter = builder(filterFields, inputValue);
      applyFilter(filter, currentDataState, setDataState);
    }
  };

  return (
    <TextField
      onChange={handleInputChanged}
      onKeyDown={handleKeyDown}
      value={inputValue}
      placeholder={findText}
      size="small"
      InputProps={{
        endAdornment: (
          <IconButton edge="end" onClick={setFilter}>
            <SearchIcon />
          </IconButton>
        ),
      }}
      sx={{ width: "200px", padding: "0.3rem", paddingBottom: "16px" }}
      {...props}
    />
  );
}
